/* created by CoolGuy on 2019/1/23 */

import AjaxAction from "../actions/AjaxAction";
import {combineReducers} from "redux";

const currentAllocationList = (state = [], action)=>{
    switch (action.type) {
        case AjaxAction.ALLOCATION_ORDER_DETAIL:
            return action.data;
        default:
            return state;
    }
}


const removeOneFrom = (type='order',list, adminid, extra)=>{
    if(! list || !list.length){
        return;
    }
    if(!adminid){
        return list;
    }
    const index = list.findIndex(l=>l.adminid===adminid);
    if( index === -1){
        console.warn('this should not happen', list);
        return list;
    }
    if(type === 'order'){
        list[index].isOrder = false;
    }else {
        list[index].isOrder = true;
    }
    extra && (list[index] = {...list[index], ...extra});
    // 注意必须返回新的数组，否则会认定没有修改
    return [...list];
}
const separateListReducer = (state = [], action)=>{
    const {one, adminid, data} = action;
    switch (action.type) {
        case AjaxAction.ALLOCATION_SORT:
            return [
                ...state,
                ...action.data,
            ]
        case AjaxAction.ALLOCATION_ORDER:
            return [
                ...action.data.map(one=>({
                    ...one,
                    isOrder:true,
                })),
                ...state,
            ]
        case AjaxAction.ALLOCATION_CANCEL:
            //取消之后删掉
            return removeOneFrom('order',state, one.adminid);
        case AjaxAction.ALLOCATION_POST:
            return removeOneFrom('sort',state,adminid,{id:data.data});
        case AjaxAction.ALLOCATION_EMPTY_SORT_LIST:
            return state.reduce((pre,cur)=>{
                if(cur.isOrder){
                    pre.push(cur);
                }
                return pre;
            },[]);
        default:
            return state;
    }
};

const currentAllocationXList = (state = [], action, op)=>{
    const { oper} = action;
    if(op === oper){
        return separateListReducer(state, action);
    }
    switch (action.type) {
        //清空所有日历数据
        case AjaxAction.ALLOCATION_EMPTY_LIST:
            return [];
        default:
            return state;
    }
}

const listWrapper = (op)=>{
    return (state, action)=>currentAllocationXList(state, action, op);
}

const setCalendarId = (state = 0, action) => {
    switch (action.type) {
        case AjaxAction.ALLOCATION_SET_CALENDAR_ID:
            return action.id;
        default:
            return state;
    }
}
const setAllocationId = (state = 0, action) => {
    switch (action.type) {
        case AjaxAction.ALLOCATION_SET_ALLOCATION_ID:
            return action.id;
        default:
            return state;
    }
}

const setCurrentTime = (state = {}, action) => {
    const {start,end} = action;
    switch (action.type) {
        case AjaxAction.ALLOCATION_SET_CURRENT_TIME:
            return {
                start,
                end,
            }
        default:
            return state;
    }
}

const calendar = (state = [], action) => {
    switch (action.type) {
        case AjaxAction.ALLOCATION_USER:
            return action.data;
        default:
            return state;
    }
}

const currentEditAllocation = (state = {},action) => {
    switch (action.type) {
        case AjaxAction.ALLOCATION_EMPTY_CURRENT_ALLOCATION:
            return {};
        case AjaxAction.ALLOCATION_DETAIL:
            return action.data;
        default:
            return state;
    }
}

// currentAllocation的结构是这样的：
// {
//  list:[],
//  pser:{
//      推荐列表，
//      已分配成员列表
// },
//  videomen:{},
//  ....
// }
const currentAllocation = combineReducers({
    list: currentAllocationList,
    pser: listWrapper('pser'),
    videomen:listWrapper('videomen'),
    cameramen:listWrapper('cameramen'),
    cliper:listWrapper('cliper'),
    workers:listWrapper('workers'),
    currentCalendarId:setCalendarId,
    currentAllocationId:setAllocationId,
    currentCalendar:calendar,
    currentTime:setCurrentTime,
    currentEditAllocation:currentEditAllocation,
});

export default {
    currentAllocation,
    currentAllocationList,
}



// WEBPACK FOOTER //
// ./src/reducers/allocationReducer.js